// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".whiteInfoTooltip{position:absolute;top:11px;right:10px;color:#fff}", ""]);
// Exports
module.exports = exports;
